export default id => `
{
    manualsSingle(id: "${id}", idType: DATABASE_ID) {
      updateDownloads
    }
}
`;
